import React, { useState, useEffect } from "react";
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { BsGrid3X3GapFill, BsFillEnvelopeFill } from "react-icons/bs";
import BellIconWithNotifications from "../notifications/notificationwidget";
import { IoMap } from "react-icons/io5";
import { FiRefreshCw } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate } from "react-router-dom";

const RenewalLogs = () => {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchLogs();
  }, [page]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${apiUrl}fetch-renewals-logs?page=${page}&limit=10`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data, pagination } = response.data;
      setLogs(data || []);
      setTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => fetchLogs();

  const handleView = (controlNo) => {
    console.log(`Viewing log details for Control No: ${controlNo}`);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Passed":
        return "bg-success";
      case "Failed":
        return "bg-danger";
      case "Pending":
        return "bg-warning text-dark";
      case "Sent to Surefyre":
        return "bg-info text-dark";
      default:
        return "bg-secondary";
    }
  };

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  return (
    <>
      <div className="dashboard-title mb-3">
        <h1 className="mb-0">Renewal Logs</h1>
        <div className="d-flex align-items-center gap-3">
          <BellIconWithNotifications />
          <div className="dropdown-container">
            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                id="dropdown-basic"
                className="rounded-circle border-0 bg-transparent"
              >
                <div
                  className="menu-icon"
                  style={{
                    fontSize: "1.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <BsGrid3X3GapFill />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-custom">
                <Dropdown.Item
                  href="/dashboard"
                  className="dropdown-item-custom"
                >
                  <BsFillEnvelopeFill className="dropdown-icon" /> Quote/Bind
                  Email
                </Dropdown.Item>
                <Dropdown.Item
                  href="/geographical-concentration"
                  className="dropdown-item-custom"
                >
                  <IoMap className="dropdown-icon" /> Geographical Concentration
                </Dropdown.Item>
                <Dropdown.Item
                  href="/renewals-dashboard"
                  className="dropdown-item-custom"
                >
                  <FiRefreshCw className="dropdown-icon" /> Renewals
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      <div className="content-body mb-3">
        <div className="filter-container">
          <div className="filterArea">
            <span className="fw-medium">Filters</span>
            {/*
            <select className="form-select" value={filterValue} onChange={(e) => setFilterValue(e.target.value)}>
              <option value="By Date Range">By Date Range</option>
              <option value="By Status">By Status</option>
              <option value="By Agent">By Agent</option>
              <option value="By Broker">By Broker</option>
            </select>
            <button className="btn btn-primary" onClick={handleApply}>Apply</button>
            */}
          </div>
          <div className="search-area">
            {/*
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            */}
            <button
              className="btn btn-primary"
              onClick={handleRefresh}
              style={{ backgroundColor: "#122066", border: "none" }}
            >
              <i className="bi bi-arrow-clockwise"></i>
              Refresh
            </button>
          </div>
        </div>
      </div>

      <div className="content-body mb-3">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Control No</th>
                <th>Policy Number</th>
                <th>Insured Name</th>
                <th>Broker</th>
                <th>Agent</th>
                <th>Status</th>
                <th className="text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : logs.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No logs found
                  </td>
                </tr>
              ) : (
                logs.map((log, index) => (
                  <tr key={log.ControlNo}>
                    <td>{(page - 1) * 10 + index + 1}</td>
                    <td>{log.ControlNo}</td>
                    <td>{log.PolicyNumber}</td>
                    <td>{log.InsuredName}</td>
                    <td>{log.Broker}</td>
                    <td>{log.Agent}</td>
                    <td>
                      <span
                        className={`badge ${getStatusBadgeClass(
                          log.RenewalStatus
                        )} text-white`}
                      >
                        {log.RenewalStatus}
                      </span>
                    </td>
                    <td className="text-end">
                      <button
                        className="btn btn-sm text-white"
                        onClick={() =>
                          navigate(`/renewals-payload/${log.ControlNo}`)
                        }
                        style={{ backgroundColor: "#122066", border: "none" }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-primary"
            onClick={handlePrevious}
            disabled={page === 1}
          >
            Previous
          </button>
          <span>
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-outline-primary"
            onClick={handleNext}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default RenewalLogs;
